import { selectBranchForCheckout } from './store/constants/cart.constant';

import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { CheckoutDataState } from "../Entites/checkoutDataState";
import {  CHECKOUT_SELECTOR, CHECKOUT_SELECTOR_Feed } from "./store/checkout.selectors";
import { CHANGE_DELIVERY_TYPE_ACTION, CHECK_VOUCHER_ACTION, Request_CHECKOUT_ACTION, Request_CHECKOUT_ACTION_Update, Select_BRANCH_ForCHeckout } from "./store/checkout.action";
import { CheckoutDataFeed } from "../Entites/checkoutFeed";




@Injectable({ providedIn: 'root' })
export class CheckOutFacades
{
  FetchCeckOut$: Observable<CheckoutDataState> = this.store.select(CHECKOUT_SELECTOR);
  Error$: Observable<CheckoutDataState> = this.store.select(CHECKOUT_SELECTOR);
  Loading$: Observable<CheckoutDataState> = this.store.select(CHECKOUT_SELECTOR);
  FetchCeckOutFeed$: Observable<CheckoutDataFeed> = this.store.select(CHECKOUT_SELECTOR_Feed)



  constructor(
    private store: Store<any>,

  ) {}







  CheckOutDataUpdate(data:CheckoutDataFeed) {
    console.log(data)
    this.store.dispatch(new Request_CHECKOUT_ACTION_Update(data))
  }



  selectBranchForCheckout(data:number) {
    console.log(data)
    this.store.dispatch(new Select_BRANCH_ForCHeckout(data))
  }

  checkVoucherAvailability(data:string) {
    console.log(data)
    this.store.dispatch(new CHECK_VOUCHER_ACTION(data))
  }


  ChangeDeliveryType(data:boolean) {
    console.log(data)
    this.store.dispatch(new CHANGE_DELIVERY_TYPE_ACTION(data))
  }

requestCheckOutData(data:CheckoutDataFeed) {
  this.store.dispatch(new Request_CHECKOUT_ACTION(data))
}

}




